export default "__VITE_ASSET__DMTaj$LL__"